import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  breakpoint: {
    thresholds: {
      lg: 1536,
    },
  },
  theme: {
    options: { variations: false },
  },
})
